/* eslint-disable */
import { CropPortrait } from '@material-ui/icons';
import { React, Fragment, Component } from 'react';
import Button from '@material-ui/core/Button';
// import Typography from '@material-ui/Typography';
// import Breadcrumbs from '@material-ui/Breadcrumbs';
// import Link from '@material-ui/Link';

import SyncList from './SyncList'

import Spinner from 'components/Spinner.js';


export default class SyncContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showSpinner: true,
      content: null,
      id: null,
      data: []
    };
  }

  componentDidMount() {
    this.reset();
  }

  reset = () => {
    this.setState({ 
      content: <SyncList setId={this.setId} />,
      showSpinner: false,
    });
  }

  render ()
  {
    return (
      <Fragment>
        <a href='#' onClick={this.reset}>Sync List</a>
        <div>
        { this.state.showSpinner ?
          <Spinner/> 
          : "" 
        }
        { this.state.content }
        </div>
      </Fragment>
    );
  }
}
